module.exports = __webpack_public_path__ + "images/emoji/small_blue_diamond.3e2b59b0a46f2177e5d4.png";